import { tw } from 'utils/classnames'

interface ShareOptionProps {
  icon: React.ReactNode
  href?: string
  onClick?: () => void
  title: string
  className?: string
  disabled?: boolean
}

export function ShareOption({
  icon,
  href,
  onClick,
  title,
  disabled = false,
  className,
}: ShareOptionProps) {
  const Component = href ? 'a' : 'button'

  return (
    <Component
      {...(Component === 'button'
        ? { onClick }
        : {
            href,
            rel: 'noreferrer',
            target: '_blank',
          })}
      title={title}
      className={tw(
        'size-8 min-[575px]:size-12',
        'bg-cf-white shadow-cf-elevation-light-1 inline-flex items-center justify-center rounded-full hover:shadow-none',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      {icon}
    </Component>
  )
}
